import { apiClient, createSuccessResponse, handleApiError } from "./api";


const circuitService = {

    async list(page = 1, pageSize = 10, filters = {}, sortBy = null, sortOrder = null){
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                pageSize: pageSize.toString(),
                ...filters
            });

            // Adicionar parâmetros de ordenação se fornecidos
            if (sortBy) {
                params.append('sortBy', sortBy);
            }
            if (sortOrder) {
                params.append('sortOrder', sortOrder);
            }

            const retorno = await apiClient.get(`/circuit?${params.toString()}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            console.error("❌ [circuitService] Erro ao listar circuitos:", processedError);
            return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
        }
    },

    async listActive(page = 1, pageSize = 10){
        try {
            var retorno = await apiClient.get(`/circuit/active?page=${page}&pageSize=${pageSize}`);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
        }
    },

    async listFilter(id){
        try {
            console.log(id)

            var retorno = await apiClient.get('/circuit/filter/'+id);

            return {
                data: retorno.data.data,
                pagination: retorno.data.pagination,
            };
        } catch (error) {
            const processedError = handleApiError(error);
            return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
        }
    },


    async edit(id){
        try {
            var retorno = await apiClient.get("/circuit/"+id);
            console.log(retorno.data)
            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
        }
    },

    async save(customer){
        try {
            console.log(customer)   

            var retorno = await apiClient.post("/circuit", customer);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
        }
    },

    async update(circuit){
        try {
            console.log(circuit)

            var retorno = await apiClient.put("/circuit", circuit);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
        }
    },

    async delete(idcircuit){
        try {
            console.log(idcircuit)

            var retorno = await apiClient.delete("/circuit/"+idcircuit);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
          success: false,
          message: processedError.message,
          status: processedError.status,
          error: processedError.error,
          code: processedError.code,
          details: processedError.details
        }
        }
    }

}

export default circuitService;